import { useEffect, useRef } from "react";

import CommonHeader from "./commonheader/CommonHeader";
import Footer from "./Footer";

import EmbroideryImgOne from "../components/assets/images/our-work-1.jpg";
import EmbroideryImgTwo from "../components/assets/images/our-work-2.jpg";
import EmbroideryImgThree from "../components/assets/images/our-work-3.jpg";
import EmbroideryImgFour from "../components/assets/images/our-work-4.jpg";
import EmbroideryImgFive from "../components/assets/images/our-work-5.jpg";
import EmbroideryImgSix from "../components/assets/images/our-work-6.jpg";
import EmbroideryImgSeven from "../components/assets/images/our-work-7.jpg";
import EmbroideryImgEight from "../components/assets/images/our-work-8.jpg";

import AccessoriesImgOne from "../components/assets/images/our-accessories-1.jpg";
import AccessoriesImgTwo from "../components/assets/images/our-accessories-2.jpg";
import AccessoriesImgThree from "../components/assets/images/our-accessories-3.jpg";
import AccessoriesImgFour from "../components/assets/images/our-accessories-4.jpg";
import AccessoriesImgFive from "../components/assets/images/our-accessories-5.jpg";

const OurWork = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    const target = headingRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          target.classList.add("animate");
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  // ✅ FANCYBOX – DELEGATED & STABLE
  useEffect(() => {
    import("@fancyapps/ui").then(({ Fancybox }) => {
      Fancybox.bind(document.body, "[data-fancybox]", {
        Thumbs: { autoStart: true },
        Toolbar: {
          display: [
            "counter",
            "zoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close",
          ],
        },
      });
    });
  }, []);

  return (
    <div>
      <CommonHeader />

      <section className="section-our-work-page section-padding">
        <div className="container">

          <h3 ref={headingRef} className="text-center mb-4">
            Our Work
          </h3>

          <div className="our-work-gallery tabs text-center">

            {/* Tabs */}

            <input type="radio" id="tab-embroidery" name="tab" defaultChecked/>
            <label htmlFor="tab-embroidery">Embroidery</label>

            <input type="radio" id="tab-accessories" name="tab" />
            <label htmlFor="tab-accessories">Accessories</label>

            <div className="content">
              <div className="row">

                {/* Embroidery */}
                {[EmbroideryImgOne, EmbroideryImgSix, EmbroideryImgThree, EmbroideryImgEight, EmbroideryImgTwo, EmbroideryImgSeven, EmbroideryImgFour, EmbroideryImgFive].map(
                  (img, i) => (
                    <div key={i} className="gallery-item embroidery col-sm-6 col-lg-3">
                      <a href={img} data-fancybox="embroidery">
                        <img src={img} className="img-fluid" alt="" />
                      </a>
                    </div>
                  )
                )}

                {/* Accessories */}
                {[AccessoriesImgOne, AccessoriesImgTwo, AccessoriesImgThree, AccessoriesImgFour, AccessoriesImgFive].map(
                  (img, i) => (
                    <div key={i} className="gallery-item accessories col-sm-6 col-lg-3">
                      <a href={img} data-fancybox="accessories">
                        <img src={img} className="img-fluid" alt="" />
                      </a>
                    </div>
                  )
                )}

              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default OurWork;
